import { render, staticRenderFns } from "./PaginationGoTo.vue?vue&type=template&id=ac3c5484&"
import script from "./PaginationGoTo.vue?vue&type=script&lang=js&"
export * from "./PaginationGoTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports